<template>
  <v-section-panel useBreak>
    <template v-slot:title>解答用紙の配点と観点の表示について</template>
    <template v-slot:content>
      <v-radio-group
        v-model="selectedIsUseAllotArea"
        hide-details
        row>
        <v-radio
          v-for="(option, index) in options"
          :key="index"
          :label="option.text"
          :value="option.value"
          color="secondary"
        ></v-radio>
      </v-radio-group>
    </template>
  </v-section-panel>
</template>

<script>
import VSectionPanel from '@/components/molecules/SectionPanel'

export default {
  components: {
    VSectionPanel,
  },
  data: () => ({
    options: [
      {text: '表示する', value: true},
      {text: '非表示にする', value: false},
    ],
  }),

  computed: {
    selectedIsUseAllotArea: {
      get() {
        return this.$store.state.sheet.isUseAllotArea;
      },
      set(value) {
        this.$store.commit('sheet/setIsUseAllotArea', { isUseAllotArea: value })
      }
    },
  },

  methods: {
    async createAnswerSeet(){
      this.$app.$refs.loading.open({type: 'print', message: 'プレビュー作成中'})
      this.$store.commit('sheet/setIsUpdate', {type: 'answerSheet', isUpdate: true})
      await this.$store.dispatch('sheet/getSheetImages', {params:{type:'answerSheet'}})
      this.$app.$refs.loading.close({})
    }
  },

  watch: {
    selectedIsUseAllotArea(now, old) {
      if (now !== old) this.createAnswerSeet()
    }
  }
}
</script>
